export const sourceDataBaseEdit = 'sourceDataBaseEdit';
